import gql from 'graphql-tag'

export const CREATE_PAGE = gql`
    mutation createPage($input: CreatePageInput!) {
        createPage(input: $input) {
            id
            parentPageIdentifier
            sortIndex
            deactivated
            isTemplate
            isStartPage
            createdAt
            updatedAt
            lastPublished
            currentVersion {
                id
                pageID
                state
                contents
                createdAt
                updatedAt
                updatedBy {
                    id
                    name
                }
                pageSettings {
                    htmlTitle
                    urlTitle
                    metaDescription
                    metaKeywords
                    robotsOption
                    includeInSitemapXML
                    pageRank
                    changeFrequency
                    language
                    translationID
                }
            }
        }
    }
`
